import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class IntraOne_ds_get_shipment_details_by_task_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { task_id: number }): 
  Promise<{ result: { Id?: number, ExpectedPackagedAmount?: number, ExpectedSourceLocationId?: number, Shipment?: { ActualWarehouseId?: number, ExpectedWarehouseId?: number, ShippingContainers?: { Id?: number }[] }, Material?: { Id?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.task_id)) {
      $missingRequiredInParams.push('\'task_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_shipment_details_by_task_id/get`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { task_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ExpectedPackagedAmount?: number, ExpectedSourceLocationId?: number, Shipment?: { ActualWarehouseId?: number, ExpectedWarehouseId?: number, ShippingContainers?: { Id?: number }[] }, Material?: { Id?: number } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.task_id)) {
      $missingRequiredInParams.push('\'task_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_shipment_details_by_task_id/getList`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { task_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ExpectedPackagedAmount?: number, ExpectedSourceLocationId?: number, Shipment?: { ActualWarehouseId?: number, ExpectedWarehouseId?: number, ShippingContainers?: { Id?: number }[] }, Material?: { Id?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.task_id)) {
      $missingRequiredInParams.push('\'task_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/datasources/ds_get_shipment_details_by_task_id/getByKeys`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      task_id: number    }) {
        if(isNil($inParams.task_id)) {
          return true; 
        }
      return false;
    }
}
